import { render, staticRenderFns } from "./user-coupon.vue?vue&type=template&id=c8c2a5e0&scoped=true&"
import script from "./user-coupon.vue?vue&type=script&lang=js&"
export * from "./user-coupon.vue?vue&type=script&lang=js&"
import style0 from "./user-coupon.vue?vue&type=style&index=0&id=c8c2a5e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c2a5e0",
  null
  
)

export default component.exports